import { computed, defineComponent, ref } from "vue";

import "./input.less";

export default defineComponent({
  name: "MInput",
  inheritAttrs: false,
  emits: ["update:modelValue", "focus", "blur", "change"],
  props: {
    modelValue: { type: [Number, String], default: "" },
    type: { type: String, default: "text" },
    placeholder: { type: String, default: undefined },
    maxLength: { type: [String, Number], default: 100 },
    disabled: { type: Boolean, default: false },
  },
  setup(props, { slots, emit }) {
    const focus = ref(false);
    const disabled = computed(() => props.disabled);

    const onInput = (event: Event) => {
      const target = event.target as HTMLInputElement;
      emit("update:modelValue", target.value);
    };

    const onFocus = (event: FocusEvent) => {
      focus.value = true;
      emit("focus", event);
    };

    const onBlur = (event: FocusEvent) => {
      focus.value = false;
      emit("blur", event);
    };

    const onChange = (event: Event) => {
      emit("change", props.modelValue, event);
    };

    const createInputNode = () => {
      return (
        <input
          class="feiyu-web-input--content-input"
          disabled={disabled.value}
          maxlength={props.maxLength}
          placeholder={props.placeholder}
          type={props.type}
          value={props.modelValue}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          onInput={onInput}
        />
      );
    };

    const createSuffixNode = () => {
      if (!slots.suffix) return null;
      return <div class="feiyu-web-input--content-suffix">{slots.suffix()}</div>;
    };

    return () => (
      <div
        class={[
          "feiyu-web-input",
          { "feiyu-web-input--disabled": disabled.value },
          { "feiyu-web-input--focus": focus.value },
        ]}
      >
        <div class="feiyu-web-input--content">
          {createInputNode()}
          {createSuffixNode()}
        </div>
      </div>
    );
  },
});
